import styled from 'styled-components';

/**
 * Simple inline list component.
 */
export const InlineList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    li {
        display: inline-block;
        vertical-align: top;
    }
    li:not(:first-child) {
        margin-left: var(--size-grid-unit);
    }
`;
